import React, { Fragment, useState, useEffect } from "react";
import { SelectPWPage } from "./0_Step";
import { SelectPOCPopulationPage } from "./1_Step";
import { AcknowledgePage } from "./2_Step";
import "../../../global/css/component/legacyStyles.scss";
import { useDebounce } from "../../Hooks";

/**
 * Reuse: modal handler for case reuse
 * @param {boolean} noPrefill: for cases where we only want to fill a P #
 * @param {boolean} open: is the reuse modal open or not
 * @param {boolean} isEmergency: is the filer filing in an emergency situation
 * @param {function} toggleModalSequence: toggle the open-ness of the linking modal
 * @param {string} formType: the 'id' of the form eg. 790A
 * @param {object} queryParameters: param object to grab case reuse data
 * @param {function} setAdditionalPrevailingWageNumber: function to set a form input's value to the PW #
 */

const ModalSequence = ({
  noPrefill,
  open,
  isEmergency,
  toggleModalSequence,
  formType,
  queryParameters,
  addPW,
  formApi,
}) => {
  const [page, setPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState(undefined);
  const [formVersion, setFormVersion] = useState(1);
  const [selectedCase, setSelectedCase] = useState(null);
  const [selectedCaseData, setSelectedCaseData] = useState({});
  const [isOutOfNetworkView, setIsOutOfNetworkView] = useState(false);
  const [formPreview, setFormPreview] = useState({
    last_name: null,
    first_name: null,
    middle_name: null,
    job_title: null,
    form_title1: null,
    form_section_info1: null,
    section1: null,
    form_title2: null,
    form_section_info2: null,
    section2: null,
  });
  const [prefillLoading, setPrefillLoading] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);

  const debouncedSearchTerm = useDebounce(searchTerm);

  useEffect(() => {
    const POCSelectionObject = {
      "9142B": {
        form_title1: "Employer Point of Contact",
        form_section_info1: "9142B Section D",
        section1: "D",
        form_title2: "Attorney/Agent Agreement",
        form_section_info2: "9142B Section E",
        section2: "E",
      },
      "9142C": {
        form_title1: "Employer Point of Contact",
        form_section_info1: "9142C Section D",
        section1: "D",
        form_title2: "Attorney/Agent Agreement",
        form_section_info2: "9142C Section E",
        section2: "E",
      },
    };
    const POCSelection = POCSelectionObject[formType];
    if (formType === "9142B" || formType === "9142C") {
      setFormPreview({
        last_name: selectedCaseData?.requestorPocLastName || null,
        first_name: selectedCaseData?.requestorPocFirstName || null,
        middle_name: selectedCaseData?.requestorPocMiddleName || null,
        job_title: selectedCaseData?.requestorPocJobTitle || null,
        ...POCSelection,
      });
    }
  }, [selectedCaseData, formType]);

  if (!open) {
    return <div></div>;
  }

  const resetState = () => {
    setPage(0);
    setSearchTerm("");
    toggleModalSequence();
    setSelectedCase(null);
    setSelectedCaseData({});
  };

  const setAcknowledgementData = () => {
    if (formType === "9089" || formType === "9142B") {
      const user_id = queryParameters?.getCasesInput?.user_id;
      const timeNow = new Date();
      const timeNowISOString = timeNow.toISOString();

      formApi.change("linkingIsNetwork", !isOutOfNetworkView);
      formApi.change("linkingAcknowledgedDate", timeNowISOString);
      formApi.change("linkingAcknowledgedBy", user_id);
    }
  };

  return (
    <Fragment>
      <SelectPWPage
        formType={formType}
        toggleModalSequence={toggleModalSequence}
        page={page}
        setPage={setPage}
        resetState={resetState}
        isEmergency={isEmergency}
        queryParameters={queryParameters}
        selectedCase={selectedCase}
        setSelectedCase={setSelectedCase}
        noPrefill={noPrefill}
        setFormVersion={setFormVersion}
        searchTerm={debouncedSearchTerm}
        setSearchTerm={setSearchTerm}
        setSelectedCaseData={setSelectedCaseData}
        addPW={addPW}
        isOutOfNetworkView={isOutOfNetworkView}
        setIsOutOfNetworkView={setIsOutOfNetworkView}
      />
      <SelectPOCPopulationPage
        toggleModalSequence={toggleModalSequence}
        page={page}
        setPage={setPage}
        resetState={resetState}
        selectedSection={selectedSection}
        setSelectedSection={setSelectedSection}
        formPreview={formPreview}
      />
      <AcknowledgePage
        formType={formType}
        toggleModalSequence={toggleModalSequence}
        page={page}
        setPage={setPage}
        resetState={resetState}
        formVersion={formVersion}
        selectedCase={selectedCase}
        selectedCaseData={selectedCaseData}
        prefillLoading={prefillLoading}
        setPrefillLoading={setPrefillLoading}
        addPW={addPW}
        formApi={formApi}
        setAcknowledgementData={setAcknowledgementData}
      />
    </Fragment>
  );
};

export default ModalSequence;
